import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "~/components/Button";
import { personalHomeRoute } from "~/routes/routes";

import { menuStateAtom } from "../state";

export const DemoButtons: React.FC = () => {
	const navigate = useNavigate();

	const handleCloseEvaluation = useCallback(() => {
		menuStateAtom.set(false);
		navigate(personalHomeRoute, { replace: true });
	}, [navigate]);

	return (
		<div className="flex md:flex-row flex-col flex-start gap-2">
			<Button
				onClick={handleCloseEvaluation}
				className="!bg-white border-transparent !text-black hover:!bg-slate-50 font-normal enabled:active:bg-slate-100 !justify-start md:justify-center"
			>
				Fechar avaliação
			</Button>
		</div>
	);
};
